import { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";

const useAdminWhatsapp = ({ Admin }) => {
  const { baseUrl, basicAuth } = useContext(GlobalContext);

  const navigate = useNavigate();

  const hasFetchedRef = useRef(false);

  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  const [locationReady, setLocationReady] = useState(false);

  const [error, setError] = useState("");
  const [locationError, setLocationError] = useState("");

  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("campaigns");

  const config = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser");
      setLocationReady(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
        setLocationReady(true);
      },
      (err) => {
        setLocationError(err.message);
        setLocationReady(true);
      }
    );
  }, []);

  // Fetch all clients
  const fetchClientCall = async () => {
    if (!Admin?.pkid) return;
    if (!baseUrl || !basicAuth) return;

    setLoading(true);

    try {
      const userDetail = {
        userid: Admin.pkid,
        latitude,
        longitude,
      };

      const response = await axios.post(
        `${baseUrl}/Admin/getAllClientList`,
        userDetail,
        config
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);

        const apiClients = response.data.response || [];

        setClients(apiClients);
        setFilteredClients(apiClients);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error while fetching clients");
      console.error("Error fetching client list:", error);
    } finally {
      setLoading(false);
    }
  };

  // Call API only once after location is ready
  useEffect(() => {
    if (!locationReady) return;
    if (!Admin?.pkid) return;
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    fetchClientCall();
  }, [locationReady, Admin?.pkid]);

  const handleSearch = (term) => {
    setSearchTerm(term);

    if (!term) {
      setFilteredClients(clients);
      return;
    }

    const lowerTerm = term.toLowerCase();

    const filtered = clients.filter((client) => {
      return (
        client?.us_name?.toLowerCase().includes(lowerTerm) ||
        client?.name?.toLowerCase().includes(lowerTerm) ||
        client?.us_code?.toLowerCase().includes(lowerTerm) ||
        client?.code?.toLowerCase().includes(lowerTerm)
      );
    });

    setFilteredClients(filtered);
  };

  const viewCampaign = (clientId) => {
    navigate(`/admin/Campaigns/${clientId}`);
  };

  const viewTemplates = (clientId) => {
    navigate(`/admin/Templates/${clientId}`);
  };

  return {
    clients,
    filteredClients,

    latitude,
    longitude,
    error,
    locationError,

    loading,
    searchTerm,
    activeTab,

    setActiveTab,
    handleSearch,
    fetchClientCall,
    viewCampaign,
    viewTemplates,
  };
};

export default useAdminWhatsapp;